import { cn } from "@/lib/cn";

/** The per-part "Approve"/"Discard" call — a segmented control rather than a checkbox, since
 * exactly one of the two always holds. Shared by the proposal table and review mode's part
 * dividers (SPCH-13/14), which set the same draft. */
export function VerdictToggle({
  verdict,
  disabled,
  onChange,
}: {
  verdict: "meeting" | "discard";
  disabled: boolean;
  onChange: (verdict: "meeting" | "discard") => void;
}) {
  return (
    <div
      role="group"
      aria-label="Verdict"
      className="inline-flex shrink-0 overflow-hidden rounded-[var(--radius-full)] border border-[var(--border-default)] text-[length:var(--text-xs)] font-semibold"
    >
      <button
        type="button"
        aria-pressed={verdict === "meeting"}
        disabled={disabled}
        onClick={() => onChange("meeting")}
        className={cn(
          "px-2.5 py-1 transition disabled:cursor-not-allowed",
          verdict === "meeting"
            ? "bg-[var(--primary)] text-[var(--primary-foreground)]"
            : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]",
        )}
      >
        Approve
      </button>
      <button
        type="button"
        aria-pressed={verdict === "discard"}
        disabled={disabled}
        onClick={() => onChange("discard")}
        className={cn(
          "px-2.5 py-1 transition disabled:cursor-not-allowed",
          verdict === "discard"
            ? "bg-[var(--text-muted)] text-[var(--primary-foreground)]"
            : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]",
        )}
      >
        Discard
      </button>
    </div>
  );
}
